import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useCampaignExternalMetadataFormFieldValue = ({ isPermitted }) => {
    return useFormFieldValue({
        field: 'externalMetadata.data',
        isPermitted,
    });
};
